import { useState, useRef, useCallback } from "react";
import { useBluelagoon } from "@bluelagoon";

export default function useWorkflowPolling() {
    const [execution, setExecution] = useState(null);
    const [executionStatus, setExecutionStatus] = useState(null);
    const pollingRef = useRef(false);
    const { call: startWorkflowCall } = useBluelagoon({ method: "startWorkflow" });
    const { call: getTaskStatusCall } = useBluelagoon({ method: "getTaskStatus" });

    const reset = useCallback(() => {
        setExecution(null);
        setExecutionStatus(null);
    }, []);

    const runWorkflow = useCallback(async (workflowId) => {
        if (!workflowId) return;
        setExecution(null);
        setExecutionStatus("polling");
        pollingRef.current = true;
        const response = await startWorkflowCall({ id: workflowId });
        const taskId = response?.data?.taskId;
        if (!taskId) {
            setExecution(response?.data || { error: "No task ID returned" });
            setExecutionStatus("done");
            return;
        }
        let attempts = 0;
        let delay = 500;
        while (attempts < 240 && pollingRef.current) {
            await new Promise((r) => setTimeout(r, delay));
            const task = await getTaskStatusCall({ taskId });
            if (task?.data?.status === "COMPLETED" || task?.data?.status === "FAILED") {
                setExecution(task.data);
                setExecutionStatus("done");
                return;
            }
            attempts++;
            delay = Math.min(delay * 1.5, 2000);
        }
        setExecution({ error: "Polling timed out" });
        setExecutionStatus("done");
    }, [startWorkflowCall, getTaskStatusCall]);

    return { execution, executionStatus, runWorkflow, reset };
}
